import VBreadcrumbs from './VBreadcrumbs.vue';
import VBreadcrumbsItem from './VBreadcrumbsItem.vue';

export {VBreadcrumbs, VBreadcrumbsItem};
export default {VBreadcrumbs, VBreadcrumbsItem};
